import React, { Component } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Tab,
  Nav,
  Button,
  Card,
  Spinner,
  Modal,
} from "react-bootstrap";
import gql from "graphql-tag";

import { withRouter } from "react-router-dom";
import { components } from "react-select";
import SelectDropDown from "../selectdropdown/SelectDropDown";
import MultiSelect from "react-multi-select-component";
import DataTableWithOutSearch from "../datatables/DataTableWithOutSearch";
import moment from "moment";
import "./_adaptive_exams.scss";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";


const DropdownIndicator = (props) =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <svg height="20" width="20" viewBox="0 0 20 20">
        <path fill="currentColor" d="M4.516 7.548l5.484 5.452 5.484-5.452" />
      </svg>
    </components.DropdownIndicator>
  );

class CreateAdaptiveExams extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nameValue: null,
      branchValue: [],
      examValue: null,
      classTypeValue: null,
      remedialExamValue: null,
      sectionValue: [],
      studentValue: [],

      branchTypeOptions: [],
      examTypeOptions: [],
      classOptions: [],
      sectionOptions: [],
      studentOptions: [],

      typeValue: "adaptive_exams",

      articlecolumns: [
        { dataField: "exam_name", text: "Exam Type", sort: true },
        { dataField: "name", text: "Exam", sort: true },
        { dataField: "branch", text: "Branch", sort: true },
        { dataField: "class", text: "Class", sort: true },
        { dataField: "section", text: "Section", sort: true },
        { dataField: "conducted_on", text: "Conducted On", sort: true },
        { dataField: "time", text: "Time", sort: true },
        { dataField: "is_completed", text: "Status", sort: true },

        {
          dataField: "view",
          formatter: this.viewFormatter,
          headerAlign: "center",
        },
        {
          dataField: "edit",
          formatter: this.editFormatter,
          headerAlign: "center",
        },
        {
          dataField: "delete",
          formatter: this.deleteFormatter,
          headerAlign: "center",
        },
      ],

      manageQuestions: [],
      loading: false,

      adaptiveSubTab: "manage_adaptive_exams",
      remedialSubTab: "manage_remedial_exams",
      selectedScheduleType: null,
      selectedScheduleSubType: null,
      adaptiveScheduledTypes: props?.getExamScheduleSubTypeQuestions || [],
      examCreationMessage: "",
      studentExamPercErrorArr: [],
      showPreviewModal: false,
      previewLoading: false,
      activeStudentIndex: 0,
      errorViewType: "greater", // greater | lesser


    };
  }



  resetForm = () => {
    this.setState({
      nameValue: null,
      branchValue: [],
      examValue: null,
      classTypeValue: null,
      remedialExamValue: null,
      sectionValue: [],
      studentValue: [],
      examCreationMessage: "",
      studentExamPercErrorArr: [],
      showPreviewModal: false,
      previewLoading: false,
      activeStudentIndex: 0,
      errorViewType: "greater", // greater | lesser
    });
  };

  componentDidMount() {
    const { globals, students = [] } = this.props;
    if (!globals) return;

    const {
      globalBranches = [],
      exams = [],
      classes = [],
      globalSections = [],
    } = globals;

    this.setState({
      branchTypeOptions: globalBranches.map((b) => ({
        label: b.branch_name,
        value: b.id,
      })),

      examTypeOptions: exams.map((e) => ({
        label: e.exam,
        value: e.id,
      })),

      classOptions: classes.map((c) => ({
        label: c.class,
        value: c.id,
      })),

      sectionOptions: globalSections.map((s) => ({
        label: s.section_name,
        value: s.id,
      })),

      studentOptions: students.map((s) => ({
        label: s.student_name,
        value: s.id,
      })),
    });
  }

  getTableExams = (data = []) =>
    data.map((item) => {
      let status = "";

      if (item.is_completed === 0) status = "Not completed";
      else if (item.is_completed === 1) status = "Completed";
      else if (item.is_completed === 2) status = "On going";

      return {
        id: item.id,
        exam_name: item.exam_name,
        name: item.name,
        branch: item.branch,
        class: item.class,
        section: item.section,

        conducted_on: moment.unix(item.start_time).format("YYYY/MM/DD"),
        time: moment.unix(item.start_time).format("LT"),

        is_completed: status,
      };
    });

  viewFormatter = (cell, row) => (
    <div className="actions-buttons">
      <Button
        variant="link"
        className="text-theme"
        onClick={() => this.handleView(row)}
      >
        <i className="far fa-eye" />
      </Button>
    </div>
  );

  editFormatter = (cell, row) => (
    <div className="actions-buttons">
      <Button
        variant="link"
        className="text-theme"
        onClick={() => this.handleEdit(row)}
      >
        <i className="far fa-edit" />
      </Button>
    </div>
  );

  deleteFormatter = (cell, row) => (
    <div className="actions-buttons">
      <Button
        variant="link"
        className="text-danger"
        onClick={() => this.handleDelete(row)}
      >
        <i className="far fa-trash-alt" />
      </Button>
    </div>
  );

  handleView = (row) => {
    this.props.history.push(
      "/questions/manage-question-paper/question-paper-result",
      {
        exam_id: row.id,
        is_completed: row.is_completed,
      }
    );
  };

  handleEdit = (row) => {
    this.props.history.push(
      "/questions/manage-question-paper/question-paper-result",
      {
        exam_id: row.id,
        is_completed: row.is_completed,
      }
    );
  };

  handleDelete = (row) => {
    this.props.handleDelete({
      variables: { exam_paper_id: row.id },
      refetchQueries: ["FETCH_EXAMS"],
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name + "Value"]: value,
    });
  };

  selecthandleInputChange = (name, value, selectedOption) => {
    this.setState({
      [name + "Value"]: selectedOption,
    });
  };

  handleMultipleSelectInputChange = (selected, name) => {
    this.setState({
      [name + "Value"]: selected,
    });
  };


  handleForExamCreationForAdaptive = async () => {

    this.setState({ examCreationMessage: "" })

    if (!this.state.studentValue.length) {
      alert("Please select students");
      return;
    }

    if (!this.state.selectedScheduleSubType) {
      alert("Please select exam type");
      return;
    }

    this.setState({ previewLoading: true });

    try {

      const result = await this.props.client.query({
        query: gql`
        query($student_ids:[String],$schedule_sub_type_id:Int){
          getStudentsExamErrorPerc(
            student_ids:$student_ids
            schedule_sub_type_id:$schedule_sub_type_id
          ){
            student_name
            status
            subjects {
              subject
              greaterthan60PercErrorChapters {
                chapter
                error
              }
              lessthan60PercErrorChapters{
                chapter
                error
              }
            }
          }
        }
      `,
        variables: {
          student_ids: this.state.studentValue.map((s) => s.value.toString()),
          schedule_sub_type_id: parseInt(this.state.selectedScheduleSubType)
        },
        fetchPolicy: "network-only"
      });

      let data = result?.data?.getStudentsExamErrorPerc || [];

      this.setState({
        studentExamPercErrorArr: data,
        showPreviewModal: true,
        previewLoading: false
      });

    } catch (err) {

      this.setState({ previewLoading: false });
      alert("Error loading preview");

    }

  };
  handleFormSubmit = (type) => {
    const {
      nameValue,
      branchValue,
      examValue,
      classTypeValue,
      sectionValue,
      studentValue,
      remedialExamValue,
      selectedScheduleSubType
    } = this.state;

    // VALIDATIONS
    if (!nameValue || nameValue.trim() === "") {
      this.setState({ examCreationMessage: "Please enter exam name" });
      return;
    }

    if (branchValue.length === 0) {
      this.setState({ examCreationMessage: "Please select branch" });
      return;
    }

    if (!examValue) {
      this.setState({ examCreationMessage: "Please select exam" });
      return;
    }

    if (!classTypeValue) {
      this.setState({ examCreationMessage: "Please select class" });
      return;
    }

    if (!sectionValue.length) {
      this.setState({ examCreationMessage: "Please select section" });
      return;
    }

    if (!studentValue.length) {
      this.setState({ examCreationMessage: "Please select students" });
      return;
    }

    if (type === "adaptive_exams" && !selectedScheduleSubType) {
      this.setState({ examCreationMessage: "Please select exam type" });
      return;
    }

    let sub_exam_type_val = 0;
    let exam_model_id = 0;
    let mains_2021 = "0";

    if (examValue?.value == 1) {
      exam_model_id = 0;
      mains_2021 = "0";
      sub_exam_type_val = 0;
    } else if (examValue?.value == 2) {
      mains_2021 = "3";
      exam_model_id = 0;
      sub_exam_type_val = 1;
    }

    const params = {
      name: nameValue,
      branch_id: branchValue.map((item) => item.value.toString()),
      exam_id: parseInt(examValue.value),
      class_id: parseInt(classTypeValue.value),
      section_ids: sectionValue.map((s) => s.value.toString()),
      student_ids: studentValue.map((s) => s.value.toString()),
      type: type === "remedial_exams" ? "remedial" : "adaptive",
      schedule_type_id: parseInt(this.state.selectedScheduleType),
      schedule_sub_type_id: parseInt(this.state.selectedScheduleSubType),
      sub_exam_type: parseInt(sub_exam_type_val),
      exam_model_id: exam_model_id,
      mains_2021: mains_2021,
      complexity_type: 4,
      complexity_custom_values: "",
      exam_mode: 1,
      question_type: "",
      questionbank_questions: "",
      autogenerate: true,
      institution_id: parseInt(Cookies.get("institutionid")),
      pattern_type: 3
    };

    this.setState({ loading: true, examCreationMessage: "" });

    this.props
      .handleCreate({
        variables: { params },
        refetchQueries: ["GetAdaptiveQuestions"]
      })
      .then((res) => {
        this.setState({ loading: false });

        if (res?.data?.createAdaptiveExamMadeEasy) {

          this.setState(
            {
              examCreationMessage: "Exam created successfully!",
              showPreviewModal: false
            },
            () => {

              // reset fields
              this.setState({
                nameValue: "",
                branchValue: [],
                examValue: null,
                classTypeValue: null,
                sectionValue: [],
                studentValue: [],
                selectedScheduleSubType: null,
                selectedScheduleType: null
              });

              // switch tab
              /*this.setState({
                adaptiveSubTab: "manage_adaptive_exams"
              });*/

              this.props.history.push({
                pathname: "/questions/manage-question-paper",
                state: {
                  activeTab: 2
                }
              });
            }
          );

        } else {
          this.setState({
            examCreationMessage: "Error creating exam. Please try again."
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          examCreationMessage: err.message || "Something went wrong"
        });
      });
  };


  handleConfirmExamCreation = () => {
    this.setState(
      {
        showPreviewModal: true
      },
      () => {
        this.handleFormSubmit("adaptive_exams");
      }
    );
  };



  handleScheduleTypeChange = (item) => {
    this.setState({
      selectedScheduleType: item.schedule_type_id,
      selectedScheduleSubType: item.schedule_sub_type_id
    });
  };

  renderTabsUI = (type, isCreation) => {
    const typeLower = type.toLowerCase().replace(" ", "_");

    const manageExamOptions = (
      this.props.manageQuestionsForDropdown ||
      this.props.manageQuestions ||
      []
    ).map((m) => ({
      label: m.name,
      value: m.id,
    }));

    const subTabKey =
      typeLower === "adaptive_exams" ? "adaptiveSubTab" : "remedialSubTab";

    return (
      <Tab.Container
        activeKey={this.state[subTabKey]}
        onSelect={(k) => this.setState({ [subTabKey]: k })}
        mountOnEnter
        unmountOnExit
      >
        {/* <Nav className="sub-tabs">
          <Nav.Item>
            <Nav.Link eventKey={`manage_${typeLower}`}>
              <i className="fas fa-list" /> Manage
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey={`create_${typeLower}`}>
              <i className="fas fa-plus-circle" /> Create
            </Nav.Link>
          </Nav.Item>
        </Nav> */}

        <Tab.Content>
          {
            !isCreation ? (
              <>
                {/* <Tab.Pane eventKey={`manage_${typeLower}`}> */}
                <DataTableWithOutSearch
                  parentData={this.getTableExams(this.props.manageQuestions)}
                  particlecolumns={this.state.articlecolumns}
                  // tableHeading={{ Title: `Manage ${type}` }}
                  name={`Manage ${type}`}
                />
                {/* </Tab.Pane> */}
              </>
            ) : (
              <>
                {/* <Tab.Pane eventKey={`create_${typeLower}`}> */}
                <Card className="adaptive-form-card">
                  {/* {typeLower === "adaptive_exams" && ( */}
                  <Row className="form-row">
                    <Col sm={12}>
                      <Form.Group>
                        {this.state.adaptiveScheduledTypes.map((item) => (
                          <Form.Check
                            key={item.schedule_sub_type_id}
                            id={`schedule-${item.schedule_sub_type_id}`}
                            inline
                            type="radio"
                            name="adaptive_schedule_type"
                            label={item.schedule_sub_type}
                            checked={
                              this.state.selectedScheduleSubType ===
                              item.schedule_sub_type_id
                            }
                            onChange={() => this.handleScheduleTypeChange(item)}
                          />
                        ))}
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* )} */}

                  <div className="zIndexCls">
                    <Row className="form-row">
                      <Col sm={6}>
                        <Form.Label>Nam1212e</Form.Label>

                        <Form.Control
                          name="name"
                          type="text"
                          placeholder={`Name of the ${type}`}
                          onChange={this.handleInputChange}
                          value={this.state.nameValue || ""}
                        />
                      </Col>
                    </Row>

                    <Row className="form-row">
                      <Col sm={3}>
                        <Form.Label>Branch</Form.Label>
                        {/* <SelectDropDown
                          stateData={this.state.branchValue}
                          handleChange={this.selecthandleInputChange}
                          name="branch"
                          options={this.state.branchTypeOptions}
                          dropdownIndicator={{ DropdownIndicator }}
                        /> */}

                        {/* <MultiSelect
                          overrideStrings={{
                            "allItemsAreSelected": "All Branches are selected.",
                            "selectSomeItems": branchlabelledBy
                          }}  
                          disableSearch={classdisableSearch}
                          hasSelectAll={branchselectall}
                          options={this.state.branchTypeOptions}
                          value={this.state.branchValue}
                          onChange={(e) => this.handleMultipleSelectInputChange(e, "branch")}
                          labelledBy={"class"}
                          name="branch"
                        /> */}

                        <MultiSelect
                          options={this.state.branchTypeOptions}
                          value={this.state.branchValue}
                          onChange={(e) =>
                            this.handleMultipleSelectInputChange(e, "branch")
                          }
                          labelledBy="Select Branch"
                        />
                      </Col>

                      <Col sm={3}>
                        <Form.Label>Exam</Form.Label>
                        <SelectDropDown
                          stateData={this.state.examValue}
                          handleChange={this.selecthandleInputChange}
                          name="exam"
                          options={this.state.examTypeOptions}
                          dropdownIndicator={{ DropdownIndicator }}
                        />
                      </Col>

                      <Col sm={3}>
                        <Form.Label>Class</Form.Label>
                        <SelectDropDown
                          stateData={this.state.classTypeValue}
                          handleChange={this.selecthandleInputChange}
                          name="classType"
                          options={this.state.classOptions}
                          dropdownIndicator={{ DropdownIndicator }}
                        />
                      </Col>

                      <Col sm={3}>
                        <Form.Label>Section</Form.Label>
                        <MultiSelect
                          options={this.state.sectionOptions}
                          value={this.state.sectionValue}
                          onChange={(e) =>
                            this.handleMultipleSelectInputChange(e, "section")
                          }
                          labelledBy="Select"
                        />
                      </Col>
                    </Row>

                    <Row >
                      <Col sm={3}>
                        <Form.Label>Students</Form.Label>
                        <div className="multiselect-wrapper">
                          <MultiSelect
                            options={this.state.studentOptions}
                            value={this.state.studentValue}
                            onChange={(e) =>
                              this.handleMultipleSelectInputChange(e, "student")
                            }
                            labelledBy="Select Students"

                          />
                        </div>

                      </Col>

                      {typeLower === "remedial_exams" && (
                        <Col sm={3}>
                          <Form.Label>Exams</Form.Label>
                          <SelectDropDown
                            stateData={this.state.remedialExamValue}
                            handleChange={this.selecthandleInputChange}
                            name="remedialExam"
                            options={manageExamOptions}
                            dropdownIndicator={{ DropdownIndicator }}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>


                  <div className="form-submit">
                    <Button
                      className="submit-btn"
                      onClick={this.handleForExamCreationForAdaptive}
                      disabled={this.state.previewLoading}
                    >
                      {this.state.previewLoading ? (
                        <>
                          <Spinner animation="border" size="sm" /> Loading...
                        </>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Card>
                {/* </Tab.Pane> */}
              </>
            )
          }
        </Tab.Content>
      </Tab.Container>
    );
  };

  render() {
    const isCreation = this.props.type === "creation";

    const studentsData = this.state.studentExamPercErrorArr || [];

    const successStudents = studentsData.filter(s => s.status === "success");
    const noWeakStudents = studentsData.filter(s => s.status !== "success");

    const isAllNoWeak = successStudents.length === 0;


    let branchselectall = true;
    let branchlabelledBy = "Select";
    let branchdisableSearch = false;

    if (this.props.globals.globalBranches.length > 0) {
      branchselectall = true;
      branchdisableSearch = false;
    }
    else {
      branchdisableSearch = true;
      branchselectall = false;
      branchlabelledBy = "Branch"
    }



    return (
      <Container fluid className="adaptive-exams-wrapper">
        {/* <Tab.Container
          defaultActiveKey="adaptive_exams"
          mountOnEnter
          unmountOnExit
          onSelect={(k) => {
            this.resetForm();
            this.setState({
              selectedScheduleType: null,
              selectedScheduleSubType: null
            });

            this.props.onTabChange && this.props.onTabChange(k);
          }}
        > */}
        <div className="adaptive-main-tabs-container">
          {/* <Nav className="main-adaptive-nav"> */}
          {/* <Nav.Item>
                <Nav.Link eventKey="adaptive_exams">
                  <i className="fas fa-brain" /> Adaptive Exams
                </Nav.Link>
              </Nav.Item> */}

          {/*<Nav.Item>
                <Nav.Link eventKey="remedial_exams">
                  <i className="fas fa-users-cog" /> Remedial Exams
                </Nav.Link>
              </Nav.Item>*/}
          {/* </Nav> */}
        </div>

        {/* <Tab.Content className="adaptive-content"> */}
        {this.props.isExamsLoading && (
          <div className="adaptive-loading">
            <Spinner animation="border" />
          </div>
        )}

        {/* <Tab.Pane eventKey="adaptive_exams"> */}
        {this.renderTabsUI("Adaptive Exams", isCreation)}
        {/* </Tab.Pane> */}

        {/* <Tab.Pane eventKey="remedial_exams">
              {this.renderTabsUI("Remedial Exams")}
            </Tab.Pane> */}
        {/* </Tab.Content>
        </Tab.Container> */}


        <Modal
          show={this.state.showPreviewModal}
          onHide={() => this.setState({ showPreviewModal: false })}
          centered
          dialogClassName="student-analysis-modal"
        >

          <Modal.Header closeButton>
            <Modal.Title>Student Error Analysis</Modal.Title>
          </Modal.Header>

          <Modal.Body>

            {this.state.previewLoading ? (

              <div className="text-center">
                <Spinner animation="border" />
              </div>

            ) : (

              <div>

                {/* STUDENT TABS */}
                <div className="student-tabs-wrapper">

                  <button
                    className="scroll-btn left"
                    onClick={() => this.studentTabsRef.scrollBy({ left: -200, behavior: "smooth" })}
                  >
                    ‹
                  </button>

                  <div
                    className="student-tabs-scroll"
                    ref={(ref) => (this.studentTabsRef = ref)}
                  >
                    <Nav variant="tabs" className="student-tabs">

                      {this.state.studentExamPercErrorArr.map((student, index) => (

                        <Nav.Item key={index}>

                          <Nav.Link
                            active={this.state.activeStudentIndex === index}
                            onClick={() =>
                              this.setState({
                                activeStudentIndex: index,
                                errorViewType: "greater"
                              })
                            }
                          >
                            {student.student_name}
                          </Nav.Link>

                        </Nav.Item>

                      ))}

                    </Nav>
                  </div>

                  <button
                    className="scroll-btn right"
                    onClick={() => this.studentTabsRef.scrollBy({ left: 200, behavior: "smooth" })}
                  >
                    ›
                  </button>

                </div>


                {/* ERROR TYPE TABS 

        <Nav variant="pills" className="mb-3 error-type-tabs">

          <Nav.Item>
            <Nav.Link
              active={this.state.errorViewType === "greater"}
              onClick={() => this.setState({ errorViewType: "greater" })}
            >
              &gt;&nbsp;60 % Error Rate
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              active={this.state.errorViewType === "lesser"}
              onClick={() => this.setState({ errorViewType: "lesser" })}
            >
              &lt;&nbsp;60 % Error Rate
            </Nav.Link>
          </Nav.Item>

        </Nav>*/}


                {/* SUBJECT CARDS */}

                {studentsData.length > 0 && (() => {

                  const activeStudent = studentsData[this.state.activeStudentIndex];

                  if (!activeStudent) return null;

                  // ❌ NO WEAK AREAS UI
                  if (activeStudent.status !== "success") {
                    return (
                      <div className="text-center mt-4">
                        <h5 className="text-danger">No Weak Areas</h5>
                        <p>This student has no chapters with error &gt; 60%</p>
                      </div>
                    );
                  }

                  // ✅ SHOW SUBJECTS
                  return (
                    <Row className="subjects-row">

                      {activeStudent.subjects.map((sub, sIndex) => {

                        const chapters =
                          this.state.errorViewType === "greater"
                            ? sub.greaterthan60PercErrorChapters
                            : sub.lessthan60PercErrorChapters;

                        if (!chapters || chapters.length === 0) return null;

                        return (
                          <Col md={4} key={sIndex} className="subject-col">
                            <Card className="subject-card h-100">
                              <Card.Body className="subject-card-body">

                                <h6 className="subject-title">{sub.subject}</h6>

                                <ul className={`chapter-list ${chapters.length > 5 ? "chapter-scroll" : ""}`}>
                                  {chapters.map((chap, cIndex) => (
                                    <li key={cIndex}>
                                      <span className="chapter-name">{chap.chapter}</span>
                                      <span className="error-percentage">{chap.error}%</span>
                                    </li>
                                  ))}
                                </ul>

                              </Card.Body>
                            </Card>
                          </Col>
                        );

                      })}

                    </Row>
                  );

                })()}

              </div>

            )}

          </Modal.Body>

          <Modal.Footer>

            <Button
              variant="secondary"
              onClick={() => this.setState({ showPreviewModal: false })}
            >
              Cancel
            </Button>

            <Button
              variant="primary"
              onClick={this.handleConfirmExamCreation}
              disabled={this.state.loading || isAllNoWeak}

            >

              {this.state.loading ? (
                <>
                  <Spinner animation="border" size="sm" /> Creating...
                </>
              ) : (
                "Create Exam"
              )}

            </Button>

            {studentsData.length > 0 && (

              <div className="text-center mt-2">

                {isAllNoWeak ? (

                  <div className="text-danger font-weight-bold">
                    ❌ All students have No Weak Areas. Exam cannot be created.
                  </div>

                ) : (

                  // <div className="text-success">

                  //   ✅ Exams will be created for:
                  //   <br />

                  //   <strong>
                  //     {successStudents.map(s => s.student_name).join(", ")}
                  //   </strong>

                  //   {noWeakStudents.length > 0 && (
                  //     <>
                  //       <br />
                  //       <span className="text-muted">
                  //         Skipped (No Weak Areas):
                  //         {" "}
                  //         {noWeakStudents.map(s => s.student_name).join(", ")}
                  //       </span>
                  //     </>
                  //   )}

                  // </div>
                  ""
                )}

              </div>

            )}

            {this.state.examCreationMessage && (
              <Row>
                <Col>
                  <div className="exam-message text-center">
                    {this.state.examCreationMessage}
                  </div>
                </Col>
              </Row>
            )}

          </Modal.Footer>

        </Modal>

      </Container>
    );
  }
}

export default withRouter(withApollo(CreateAdaptiveExams));
